export const defaultClinicTheme = {
  logo: {
    alt: 'Clinic Logo',
    url: '',
    link: '#',
    width: 'auto',
    height: '60px',
    position: 'left',
    visibleInMobile: true,
  },
  theme: {
    mode: 'light',
    colors: {
      primary: '#2E8B57',
      primaryLight: '#3CB371',
      primaryDark: '#228B22',
      secondary: '#696969',
      secondaryLight: '#808080',
      success: '#28a745',
      info: '#17a2b8',
      warning: '#ffc107',
      danger: '#dc3545',
      light: '#f8f9fa',
      dark: '#343a40',
      background: '#ffffff',
      surface: '#fafafa',
      text: '#2c3e50',
      textMuted: '#7f8c8d',
      border: '#bdc3c7',
    },
    fonts: {
      primary: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
      size: {
        small: '0.875rem',
        base: '1rem',
        large: '1.25rem',
        xl: '1.5rem',
      },
    },
    borderRadius: '0.5rem',
    shadows: {
      sm: '0 2px 4px 0 rgb(0 0 0 / 0.05)',
      base: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
      lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    },
  },
  header: {
    layout: 'default',
    sticky: true,
    showBorder: true,
    height: 'auto',
    padding: {
      top: '1rem',
      bottom: '1rem',
    },
    textColor: '#ffffff',
    backgroundColor: 'auto',
    showLogo: true,
    logoPosition: 'left',
    logoPositionMobile: 'center',
    logoHeight: '60px',
    logoHeightMobile: '40px',
    showClinicName: true,
    clinicNamePosition: 'left',
    clinicNameSize: '1.5rem',
    showContactInfo: false,
    showContactInfoMobile: false,
    contactInfoPosition: 'right',
    showAddress: true,
    showPhone: true,
    showFax: false,
    showEmail: false,
    showWebsite: false,
    contactInfoTextColor: '#ffffff',
    contactInfoTextSize: '0.875rem',
    showSocialIcons: false,
    socialIconsPosition: 'right',
    showSocialIconsMobile: false,
  },
  footer: {
    layout: 'detailed',
    text: '© 2025 <<CLINIC_NAME>>. All rights reserved.',
    showPoweredBy: true,
    poweredByText: 'Powered by',
    poweredByLabel: 'EyeconX',
    poweredByUrl: 'https://eyeconx.com',
    showLinks: true,
    links: [
      { text: 'Privacy Policy', url: '#' },
      { text: 'Terms of Service', url: '#' },
      { text: 'Contact Us', url: '#' },
    ],
    showContactInfo: true,
    showClinicHours: true,
    showSocialIcons: false,
    backgroundColor: 'auto',
    textColor: '#ffffff',
    quickLinksFontSize: '0.875rem',
  },
  animations: {
    enabled: true,
    duration: '0.3s',
    easing: 'ease-in-out',
  },
  responsive: {
    breakpoints: {
      mobile: '576px',
      tablet: '768px',
      desktop: '992px',
      wide: '1200px',
    },
    hideElements: {
      mobileHideTagline: true,
      mobileHideAddress: false,
      mobileHideEmail: true,
    },
  },
  accessibility: {
    focusVisible: true,
    highContrast: false,
    skipToContent: true,
    announcePageChanges: true,
  },
}

export const remToPx = (remValue) => {
  if (typeof remValue === 'string' && remValue.endsWith('rem')) {
    return parseFloat(remValue) * 16
  }
  return parseFloat(remValue) || 14
}

export const formatClinicAddress = (address) => {
  if (!address) return ''
  if (typeof address === 'string') return address
  const parts = [
    address.street,
    address.city,
    address.province,
    address.postalCode,
    address.country,
  ]
  return parts.filter(Boolean).join(', ')
}

export const mergeClinicThemeResponse = (data) => {
  let updatedTheme = { ...defaultClinicTheme, ...(data?.themeContent || {}) }

  if (
    data?.clinicContent?.logo?.url &&
    updatedTheme.logo?.url === '<<CLINIC_LOGO>>'
  ) {
    updatedTheme = {
      ...updatedTheme,
      logo: {
        ...updatedTheme.logo,
        url: data.clinicContent.logo.url,
        alt: data.clinicContent.logo.alt || updatedTheme.logo.alt,
        link: data.clinicContent.logo.link || updatedTheme.logo.link,
      },
    }
  }

  return {
    theme: updatedTheme,
    clinicContent: data?.clinicContent || null,
  }
}

export const resolveThemeColor = (value, fallback) =>
  value === 'auto' || !value ? fallback : value

/** Soft tint of a hex color for atmospheric backgrounds */
export const hexToRgba = (hex, alpha = 0.12) => {
  if (!hex || typeof hex !== 'string') return `rgba(46, 139, 87, ${alpha})`
  let h = hex.replace('#', '')
  if (h.length === 3) {
    h = h
      .split('')
      .map((c) => c + c)
      .join('')
  }
  if (h.length !== 6) return `rgba(46, 139, 87, ${alpha})`
  const r = parseInt(h.slice(0, 2), 16)
  const g = parseInt(h.slice(2, 4), 16)
  const b = parseInt(h.slice(4, 6), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
